import React from 'react';
import VegetableStore from './VegetableStore';

function App() {
  return (
    <div className="App">
      <VegetableStore />
    </div>
  );
}

export default App;